// import EntypoIcon from 'react-native-vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUISalePagePixelView from 'xui/modules/storeWebsite/BaseUISalePagePixelView'

export default class SalePagePixelView extends BaseUISalePagePixelView {}
